import React,{useState, useEffect} from "react";
import { TitleText } from "../../../ui/Text";
import { RadioInput } from "../../../ui/RadioInput";
import { GetHook } from "../../../api/api";
import { SCORECARD_URL, KPI_URL } from "../../../api/urls";
import { get } from "../../../utils/get";
import { Field } from "formik";
import Input from "../../../ui/Input";
import MyLoader from "../../../assets/svg/MyLoader";
import {ClipBoard} from "../../../assets/svg/ClipBoard"
import { AnyAaaaRecord, AnyMxRecord } from "dns";
import axios from "axios";
interface IProps {
  scorecardId: string;
}
export const ReviewPerspective = ({ scorecardId }: IProps) => {
  let { data: perspectives,pending } = GetHook(
    `${SCORECARD_URL}/${scorecardId}/perspective`
  );
  // const [perspectiveInfo,setPerspectiveInfo] = useState<any>([])
  // // console.log(kpiData)
  // useEffect(() => {
  //   let promises : any = []
  //   let data : any = []
  //   perspectives.map((perspective:any) => (
  //     promises.push(axios.get(`${SCORECARD_URL}/${scorecardId}/kpi?perspective_id=${perspective.perspective_id}`))
  //   ))
  //   // console.log(promises);
  //   Promise.all(promises).then(promiseValue => {
  //     // console.log(promiseValue);
  //     promiseValue.map((theValue:any) => {
  //       const results = theValue.data.returned_resultset
  //       // console.log(results);
        
  //       // if (results.kpi_questions.length) {
  //       //   data.push(results)
  //       // }
  //       setPerspectiveInfo (results)
        
  //     })
  //     }
  //   )
  //   return () => {
      
  //   }
  // }, [perspectives])
//  console.log(perspectiveInfo);
 
  // if (kpiInfo.length<1) {
  //   return <ClipBoard/>
  // }

  // const [kpiInfo,setKpiInfo] = useState<any>([])
  // // console.log(kpiData)
  // useEffect(() => {
  //   let promises : any = []
  //   let data : any = []
  //   perspectiveInfo.map((kpi:any) => (
  //     promises.push(axios.get(`${KPI_URL}/${kpi.kpi_id}`))
  //   ))
  //   // console.log(promises);
  //   Promise.all(promises).then(promiseValue => {
  //     // console.log(promiseValue);
  //     promiseValue.map((theValue:any) => {
  //       const results = theValue.data.returned_resultset[0]
  //       if (results.kpi_questions.length) {
  //         data.push(results)
  //       }
        
  //     })
  //     }
  //   )
  //   setKpiInfo (data)
  //   return () => {
      
  //   }
  // }, [perspectiveInfo])

  // console.log(perspectiveInfo);
  
  // if (kpiInfo.length<1) {
  //   return <ClipBoard/>
  // }
  return (
    <>
     <>
    {pending && (<MyLoader/>)}
    </>
      {perspectives.map((perspective) => (
        <PerspectiveData
          perspectiveId={get(perspective, "perspective_id")}
          scorecardId={scorecardId}
        />
      ))}
    </>
  );
};

interface QProps {
  scorecardId: string;
  perspectiveId: string;
}
const PerspectiveData = ({ perspectiveId, scorecardId }: QProps) => {
  let { data: kpiData,pending } = GetHook(
    `${SCORECARD_URL}/${scorecardId}/kpi?perspective_id=${perspectiveId}`
  );

  // const [kpiInfo,setKpiInfo] = useState<any>([])
  // // console.log(kpiData)
  // useEffect(() => {
  //   let promises : any = []
  //   let data : any = []
  //   kpiData.map((kpi:any) => (
  //     promises.push(axios.get(`${KPI_URL}/${kpi.kpi_id}`))
  //   ))
  //   // console.log(promises);
  //   Promise.all(promises).then(promiseValue => {
  //     // console.log(promiseValue);
  //     promiseValue.map((theValue:any) => {
  //       const results = theValue.data.returned_resultset[0]
  //       if (results.kpi_questions.length) {
  //         data.push(results)
  //       }
        
  //     })
  //     }
  //   )
  //   setKpiInfo (data)
  //   return () => {
      
  //   }
  // }, [kpiData])
  // if (kpiInfo.length<1) {
  //   return <ClipBoard/>
  // }
  return (
    <>
     <>
    {pending && (<MyLoader/>)}
    </>
      {kpiData.map((kpi) => (
        <KPIQuestion questions={get(kpi, "kpi_questions")} kpiId={get(kpi, "kpi_id")} />
      ))}
    </>
  );
};

const KPIQuestion = ({ kpiId, questions }: { kpiId: string;questions: []}) => {
  let { data: kpiInfo,pending } = GetHook(`${KPI_URL}/${kpiId}`);

  // let kpiQstn = get(kpiInfo, "[0].kpi_questions", [])
  // console.log(kpiInfo);
  
  const ValidateComment = (value) => {
    let error;

    if (!value) {
      error = "Comment is Required";
    }

    return error;
  };
  return ( 
    <>
     {/* {!pending && kpiQstn.length < 1 && (<ClipBoard/>)}  */}
    <>
    {pending && (<MyLoader/>)}
    </>
    <>
    {get(kpiInfo, "[0].kpi_questions", []).map((kpi, index) => (
        <div key={index} style={{ marginBottom: "2em" }}>
          <TitleText>{`${get(kpi, "question", "")}`}</TitleText>
          <div
            style={{
              marginTop: "0.5em",
              marginRight: "2em",
            }}
          >
            <div
              style={{
                display: "flex",
                alignSelf: "flex-start",
                marginBottom: "1em",
              }}
            >
              {get(kpi, "answers", []).map((answer) => {
                return (
                  <RadioInput
                    name={get(kpi, "id", "")}
                    label={get(answer, "answer", "")}
                    value={JSON.stringify({answerId:get(answer, "id", ""),points:get(answer,"points","")})}
                    type="radio"
                  />
                );
              })}
            </div>
            <Field
              name={`${get(kpi, "id", "")}_comment`}
              component={Input}
              type="textarea"
              placeholder="Comment"
              height="3rem"
              validate={ValidateComment}
              width="40%"
            />
          </div>
        </div>
      ))}
    </>
    </>
    
  );
};
